import axios from "axios";

export default function useGetShippingOptions() {
  const getShippingOptions = async () => {
    const response = await axios.get(
      window.location.origin +
        "/wp-json/wp/v2/produkter/frakter?_fields=title,acf,id,type,slug,featured_media&orderby=menu_order&order=asc"
    );

    //Extracting data from response
    const data = response.data;

    //Remapping object
    const shippingOptions = [
      ...data.map((shippingOption) => ({
        id: shippingOption.id,
        slug: shippingOption.slug,
        type: shippingOption.type,
        title: shippingOption.title.rendered,
        price: shippingOption.acf.pris,
      })),
    ];

    return shippingOptions;
  };

  return {
    getShippingOptions,
  };
}
